// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Reports-Sales-CategorySales-__CategorySales___1cFHn","tableWrapper":"app-pages-Reports-Sales-CategorySales-__CategorySales___31YCU","header_panel":"app-pages-Reports-Sales-CategorySales-__CategorySales___Ip5Xl","tableWrapperResponsive":"app-pages-Reports-Sales-CategorySales-__CategorySales___DmG4C","body_gross_margin":"app-pages-Reports-Sales-CategorySales-__CategorySales___2r4mJ","foot_gross_margin":"app-pages-Reports-Sales-CategorySales-__CategorySales___1edFv","thickTitle":"app-pages-Reports-Sales-CategorySales-__CategorySales___1CTMS"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Reports/Sales/CategorySales/CategorySales.css
// module id = 2213
// module chunks = 0